
import SectionCard from "./sectioncard.tsx";
import React, { useEffect, useState } from 'react';
import { Card } from '../card';
import { CreditCard, PenLine, Eye, Wallet, FileText, Smartphone, Users, Trash2, Check, Plus, Upload, Download, ChevronDown, ChevronUp } from 'lucide-react';


import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../state/store.ts";
import axios from "axios";
import { setActiveTab } from '../../../state/tab/tabSlice.ts';
// Lightweight flag buttons (avoid external libs that can break SSR/bundlers)
// function FlagButton({ label, active, onClick, emoji }) {
//     return (
//         <button
//             onClick={onClick}
//             title={label}
//             className={`flex items-center justify-center w-8 h-6 rounded-sm border transition ${active ? 'opacity-100 border-purple-400' : 'opacity-60 border-transparent hover:opacity-100'
//                 }`}
//             aria-pressed={active}
//             type="button"
//         >
//             <span aria-hidden className="text-lg leading-none">{emoji}</span>
//             <span className="sr-only">{label}</span>
//         </button>
//     );
// }

export default function CustomerPayments({ currentUser, baseUrl }: { currentUser: any, baseUrl: string }) {
    const client = useSelector((state: RootState) => state.client.client);
    const client_uid = client.uid || "clnt_QI9Jd1m0"; // fallback to default if not available
    const default_configs = client ? JSON.parse(client.default_configs) : {};
    const [defaultMethod, setDefaultMethod] = useState('kort');
    const [language, setLanguage] = useState('no');
    const [showAuthorized, setShowAuthorized] = useState(false);
    const [showAddNumber, setShowAddNumber] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [customer, setCustomer] = useState<any>(null);

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        try {
            axios.get(baseUrl + '/getCustomerByUID', {
                params: { token: currentUser.token, client_uid: client_uid }
            }).then((res) => {
                if (res.data.status === "OK") {
                    const data = res.data.data;
                    setCustomer(data);
                }
            })
        } catch (err) {
            console.error("Error fetching profile:", err);
        } finally {
            setLoading(false);
        }
    }, [customer, currentUser, baseUrl])

    const activeTab = useSelector((state: RootState) => state.tab.activeTab);
    const dispatch = useDispatch();

    const translations: any = {
        no: {
            card: 'Kort',
            vipps: 'Vipps',
            invoice: 'Faktura',
            wallet: 'Lommebok',
            authorized: 'Klarerte telefonnumre (for ansatte / delt tilgang)',
            name: 'Navn',
            phone: 'Telefonnummer',
            empId: 'Ansatt-ID',
            usage: 'Akkumulert forbruk',
            action: 'Handling',
            uploadCSV: 'Last opp CSV',
            downloadCSV: 'Last ned CSV',
            addUser: 'Legg til bruker',
            hideForm: 'Skjul skjema',
            add: 'Legg til',
            activity: 'Aktivitet for',
            advisor: 'Veileder',
            service: 'Tjeneste',
            minutes: 'Minutter',
            amount: 'Beløp',
        },
        // en: {
        //     title: 'Payment Methods main number +47 400 00 000',
        //     card: 'Card',
        //     vipps: 'Vipps',
        //     invoice: 'Invoice',
        //     wallet: 'Wallet',
        //     authorized: 'Authorized phone numbers (for staff / shared access)',
        //     name: 'Name',
        //     phone: 'Phone number',
        //     empId: 'Employee ID',
        //     usage: 'Total usage',
        //     action: 'Action',
        //     uploadCSV: 'Upload CSV',
        //     downloadCSV: 'Download CSV',
        //     addUser: 'Add user',
        //     hideForm: 'Hide form',
        //     add: 'Add',
        //     activity: 'Activity for',
        //     advisor: 'Advisor',
        //     service: 'Service',
        //     minutes: 'Minutes',
        //     amount: 'Amount',
        // },
    };

    const t = translations[language];

    const paymentMethods = [
        { id: 'kort', name: t.card, description: 'Visa / Mastercard (primær og sekundær)', expiry: '12/2027', type: 'card' },
        {
            id: 'vipps', name: t.vipps, description: customer?.sub
                ? "Tilknyttet Vipps-konto \n"+customer?.vipps_connected_phone
                : "Klikk for å koble til Vipps", type: 'vipps'
        },
        { id: 'invoice', name: t.invoice, type: 'invoice', forfall: '15.11.2025', neste: '15.12.2025', sum: '3 480 NOK' },
        { id: 'wallet', name: t.wallet, type: 'wallet', saldo: '2 100 NOK' },
    ];

    const [authorizedNumbers, setAuthorizedNumbers] = useState([
        { id: 1, name: 'Anna Nilsen', number: '+47 988 22 111', employeeId: 'A102', totalUsage: '1 200 NOK' },
        { id: 2, name: 'Ola Berg', number: '+47 977 33 222', employeeId: 'A103', totalUsage: '870 NOK' },
    ]);

    const [newNumber, setNewNumber] = useState({ name: '', number: '', employeeId: '' });

    const handleAddNumber = () => {
        if (!newNumber.name.trim()) return;
        const id = Math.max(0, ...authorizedNumbers.map((n) => n.id)) + 1;
        setAuthorizedNumbers([...authorizedNumbers, { id, ...newNumber, totalUsage: '0 NOK' }]);
        setNewNumber({ name: '', number: '', employeeId: '' });
    };

    const handleDelete = (id: any) => {
        setAuthorizedNumbers(authorizedNumbers.filter((n) => n.id !== id));
    };
    const handleInvoiceClick = () => {
        window.open(customer?.billing_portal_url, "_blank");
    }
    const handleVippsClick = () => {
        if (default_configs?.vipps_pay === "yes" && !customer?.sub) {
            let vipps_client_id = default_configs?.vipps_client_id || "";
            let redirect_uri = "";
            let endpoint = "";
            if (baseUrl.includes("localhost")) {
                redirect_uri = "http://localhost:3000/customer/dashboard?vipps_auth=1";
            } else {
                redirect_uri = window.location.origin + "/customer/dashboard?vipps_auth=1";
            }
            if (default_configs?.vipps_account_mode === "test") {
                endpoint = "https://apitest.vipps.no/";
            } else {
                endpoint = "https://api.vipps.no/";
            }
            window.location.href = `${endpoint}access-management-1.0/access/oauth2/auth?client_id=${vipps_client_id}&response_type=code&scope=openid%20name%20phoneNumber%20address%20birthDate%20email&state=8652682f-ba1d-4719-b1ec-8694ba97bde7&redirect_uri=${redirect_uri}`;
        }
    }
    const allowedPaymentMethods = paymentMethods.filter((method) => {
        if (method.type === "wallet" && default_configs.wallet_payment === "yes") return true;
        if (method.type === "invoice" && default_configs.invoice_payment === "yes") return true;
        if (method.type === "vipps" && default_configs.vipps_pay === "yes") return true;
        if (method.type === "card" && default_configs.card_payment === "yes") return true;
        return false;
    });
    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="flex flex-col items-center">
                    <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                    <p className="mt-3 text-gray-600 animate-pulse">Laster inn betalingsmetoder</p>
                </div>
            </div>
        );
    }

    const handleWalletClick = () => {
        dispatch(setActiveTab("Lommebok"));
    }
    return (
        <SectionCard title="Betalingsmetoder" icon={<CreditCard className="h-5 w-5 text-purple-700" />}>
            <div className="max-w-5xl mx-auto mt-8 bg-white rounded-2xl p-6 shadow-sm">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-purple-700">Betalingsmetoder hovednummer {customer?.country + " " + customer?.phone}</h2>
                    {/* <div className="flex gap-2">
                        <FlagButton label="Norsk" emoji="🇳🇴" active={language === 'no'} onClick={() => setLanguage('no')} />
                        <FlagButton label="English" emoji="🇬🇧" active={language === 'en'} onClick={() => setLanguage('en')} />
                    </div> */}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                    {allowedPaymentMethods.map((method) => (
                        <Card
                            {...(method.type === "invoice" || method.type === "card" ? { onClick: handleInvoiceClick } : method.type === "wallet" ? { onClick: handleWalletClick } : method.type === "vipps" ? { onClick: handleVippsClick } : {})}
                            key={method.id}
                            className={`${method.type === "invoice" || "card" ? `cursor-pointer` : ``} relative border rounded-xl p-4 flex flex-col justify-between text-center shadow-sm transition-all duration-300 ${defaultMethod === method.id ? 'border-purple-300 bg-purple-50/40' : 'border-gray-200'
                                }`}
                        >
                            <div>
                                <div className="bg-purple-50 p-4 rounded-full mb-3 mx-auto w-fit">
                                    {method.type === 'wallet' ? (
                                        <Wallet className="text-purple-500 w-6 h-6" />
                                    ) : method.type === 'invoice' ? (
                                        <FileText className="text-purple-500 w-6 h-6" />
                                    ) : method.type === 'vipps' ? (
                                        <Smartphone className="text-purple-500 w-6 h-6" />
                                    ) : (
                                        <CreditCard className="text-purple-500 w-6 h-6" />
                                    )}
                                </div>
                                <p className="font-medium text-gray-800 text-sm">{method.name}</p>
                                {method.description && <p className="text-xs text-gray-500 whitespace-pre-line">{method.description}</p>}
                            </div>
                        </Card>

                    ))}
                </div>

                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                    <div className="flex justify-between items-center cursor-pointer" onClick={() => setShowAuthorized(!showAuthorized)}>
                        <h3 className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                            <Users className="w-4 h-4 text-purple-500" /> {t.authorized}
                        </h3>
                        {showAuthorized ? <ChevronUp className="w-4 h-4 text-gray-500" /> : <ChevronDown className="w-4 h-4 text-gray-500" />}
                    </div>

                    {showAuthorized && (
                        <div className="mt-3">
                            <div className="flex justify-end gap-3 mb-3 text-xs">
                                <label className="flex items-center gap-1 text-gray-600 hover:text-gray-800 cursor-pointer">
                                    <Upload className="w-4 h-4" /> {t.uploadCSV}
                                    <input type="file" accept=".csv,text/csv" className="hidden" />
                                </label>
                                <button className="flex items-center gap-1 text-gray-600 hover:text-gray-800">
                                    <Download className="w-4 h-4" /> {t.downloadCSV}
                                </button>
                                <button onClick={() => setShowAddNumber(!showAddNumber)} className="flex items-center gap-1 text-purple-600 hover:text-purple-800">
                                    <Plus className="w-4 h-4" /> {showAddNumber ? t.hideForm : t.addUser}
                                </button>
                            </div>

                            {showAddNumber && (
                                <div className="flex flex-wrap gap-2 mb-4 bg-white p-3 rounded-lg border border-gray-200">
                                    <input className="border border-gray-300 rounded-md px-2 py-1 text-xs flex-1" placeholder={t.name} value={newNumber.name} onChange={(e) => setNewNumber({ ...newNumber, name: e.target.value })} />
                                    <input className="border border-gray-300 rounded-md px-2 py-1 text-xs flex-1" placeholder={t.phone} value={newNumber.number} onChange={(e) => setNewNumber({ ...newNumber, number: e.target.value })} />
                                    <input className="border border-gray-300 rounded-md px-2 py-1 text-xs w-24" placeholder={t.empId} value={newNumber.employeeId} onChange={(e) => setNewNumber({ ...newNumber, employeeId: e.target.value })} />
                                    <button onClick={handleAddNumber} className="bg-purple-600 text-white text-xs rounded-md px-3 py-1 hover:bg-purple-700">{t.add}</button>
                                </div>
                            )}

                            <table className="w-full text-xs text-gray-700 border border-gray-100 rounded-lg">
                                <thead className="bg-gray-100 text-gray-600">
                                    <tr>
                                        <th className="py-2 px-3 text-left">{t.name}</th>
                                        <th className="py-2 px-3 text-left">{t.phone}</th>
                                        <th className="py-2 px-3 text-left">{t.empId}</th>
                                        <th className="py-2 px-3 text-left">{t.usage}</th>
                                        <th className="py-2 px-3 text-right">{t.action}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {authorizedNumbers.map((num) => (
                                        <tr key={num.id} className="border-t border-gray-100 bg-white hover:bg-purple-50 cursor-pointer" onClick={() => setSelectedUser(selectedUser === num.name ? null : num.name)}>
                                            <td className="py-2 px-3 font-medium text-purple-700">{num.name}</td>
                                            <td className="py-2 px-3">{num.number}</td>
                                            <td className="py-2 px-3">{num.employeeId}</td>
                                            <td className="py-2 px-3">{num.totalUsage}</td>
                                            <td className="py-2 px-3 text-right">
                                                <button onClick={() => handleDelete(num.id)} className="text-red-400 hover:text-red-600" title="Slett">
                                                    <Trash2 className="w-4 h-4 inline-block" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </SectionCard>

    )
}